import { getRecordingAssetWatchingProgress, RecordingAsset, RecordingSettings } from '@kaltura-ott/tvpil-shared';
import { Bookmark } from '@kaltura-ott/tvpil-shared/lib/rhino/data/asset';

import { useWidgetContext } from 'context/widgetProvider/widgetProvider';

import { isStandaloneRecordingAsset } from '../../utils';

export const useWatchingProgress = (recording: RecordingAsset, bookmark: Bookmark | undefined) => {
  const { settings } = useWidgetContext<RecordingAsset, RecordingSettings>();

  if (!isStandaloneRecordingAsset(recording)) {
    return undefined;
  }

  const padding = settings.recordingPaddingEnd ?? 0;

  return getRecordingAssetWatchingProgress({ asset: recording, bookmark }, padding);
};
